import React from 'react';
import LayoutMixin from 'js/mixins/layout';
import BetelgeuseMixin from 'js/mixins/betelgeuse';
import BackboneMixin from 'js/mixins/backbone';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

const EmptyLayout = createReactClass({
  propTypes: {
    alert: PropTypes.object,
    modal: PropTypes.object,
    page: PropTypes.func,
  },

  mixins: [BackboneMixin, BetelgeuseMixin, LayoutMixin],

  render() {
    // Create our page representation passing constructed props
    const {alert, modal, page} = this.props,
      pageElement = React.createElement(page, this.getPageData());

    return <div onClick={this.onClick} ref="top">
      <div ref="container" className="sitecontainer">
        {alert}
        {pageElement}
      </div>
      {modal}
    </div>;
  },
});

module.exports = EmptyLayout;



// WEBPACK FOOTER //
// ./app/assets/jsx/layouts/empty.jsx